/** @format */

import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AsyncPipe } from '@angular/common';
import { FilterChipsComponent } from '../filter-chips/filter-chips.component';
import { Store } from '@ngrx/store';
import { selectProductListSEOName } from '@plp/data-access/state';

@Component({
	selector: 'plp-components-no-filtered-results',
	imports: [AsyncPipe, FilterChipsComponent],
	templateUrl: './no-filtered-results.component.html',
	styleUrl: './no-filtered-results.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoFilteredResultsComponent {
	categoryName$ = this.store.select(selectProductListSEOName);

	constructor(private readonly store: Store) {}
}
